@use '../../utils.scss';

.DragElement {
	pointer-events: none;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 2px solid utils.color('nebula');
	color: 'red';
	box-shadow: 0 7px 10px 2px rgba(0, 0, 0, 0.25);
}

.DragImage {
	pointer-events: none;
	image-rendering: -moz-crisp-edges; /* Firefox */
	image-rendering: -o-crisp-edges; /* Opera */
	image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
	image-rendering: crisp-edges;
	-ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
    width: 100%;
    height: 100%;
    object-fit: scale-down
}

.DragOuter {
	pointer-events: none;
	border: 2px solid utils.color('nebula');
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 7px 10px 2px rgba(0, 0, 0, 0.25);
}